import { evalShowWhen } from './show-when'
import type { JsonMap } from './json'

export function evalFolderExpr(
  expr: string | undefined,
  opts: {
    inputs: JsonMap
    priorInputs: JsonMap
    settings: JsonMap
    context: JsonMap
  }
) {
  // if there's no filter, we default to showing it
  if (!expr) {
    return true
  }

  return evalShowWhen(expr, {
    inputs: opts.inputs,
    priorInputs: opts.priorInputs,
    settings: opts.settings,
    context: opts.context
  })
}
